"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _index = _interopRequireDefault(require("./index"));

var Form = function simpleFormComponent(_ref) {
  var formData = _ref.formData,
      controls = _ref.controls,
      reportControlValues = _ref.reportControlValues,
      customRenderer = _ref.customRenderer,
      classPrefixOverride = _ref.classPrefixOverride,
      controlsRendererMap = _ref.controlsRendererMap,
      validateControls = _ref.validateControls,
      passThroughProps = _ref.passThroughProps,
      resetForm = _ref.resetForm;

  if (customRenderer) {
    return customRenderer(formData, controls, reportControlValues, classPrefixOverride, validateControls, passThroughProps, resetForm);
  }

  return controls.map(function (control) {
    var Control = control.Control,
        fieldData = control.fieldData;
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: fieldData.id,
      className: "advisor-form__control-row"
    }, /*#__PURE__*/_react["default"].createElement(Control, {
      fieldData: fieldData,
      classPrefixOverride: classPrefixOverride,
      reportControlValues: reportControlValues,
      fieldId: fieldData.id,
      customControlRenderer: controlsRendererMap[fieldData.control.type],
      validateControls: validateControls,
      resetForm: resetForm
    }));
  });
};

var _default = (0, _index["default"])(Form);

exports["default"] = _default;